import { socialImgs } from "../constants";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="flex flex-col justify-center">
          <p>Conditions générales</p>
        </div>
        <div className="socials">
          {socialImgs.map((socialImg, index) => (
            <a
              key={index}
              href={socialImg.link} // lien vers LinkedIn ou autre
              target="_blank"
              rel="noopener noreferrer"
              className="icon"
            >
              <img src={socialImg.imgPath} alt="social icon" />
            </a>
          ))}
        </div>
        <div className="flex flex-col justify-center md:pb-0 pb-10">
          <p className="text-center md:text-end">
            © {new Date().getFullYear()} Goulven RONARC'H. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;